<template>
  <div class="slice slice--thumbnail-with-description">
    <hr v-if="hasSeparator">
    <div class="grid-x grid-padding-x">
      <div class="cell small-12 medium-4 cell--thumbnail">
        <PrismicImage v-if="image" :field="image" />
      </div>
      <div class="cell small-12 medium-8 cell--content">
        <PrismicRichText v-if="content" :field="content" />
      </div>
    </div>
  </div>
</template>

<script>
  import PrismicImage from '~/modules/cms/components/prismic/prismic-image'
  import PrismicRichText from '~/modules/cms/components/prismic/rich-text'

  export default {
    name: 'ThumbnailWithDescriptionSlice',
    components: {
      PrismicImage,
      PrismicRichText,
    },
    props: {
      slice: {
        default: () => {},
        type: Object,
      },
    },
    computed: {
      content () {
        return this.$get(this.slice, 'primary.content1', null)
      },
      hasSeparator () {
        return this.$get(this.slice, 'primary.separator', 'No') === 'Yes'
      },
      image () {
        return this.$get(this.slice, 'primary.thumbnail', null)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .slice--thumbnail-with-description {
    .cell--content {
      /deep/ section {
        h2:first-child,
        h3:first-child {
          margin-top: 0;
        }
        p:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
</style>
